<template>
  <fragment>
    <default-header
      :h2="disablePlates ? $t('ScanPlates.titleIfCameraViewIsNotVisible') : $t('ScanPlates.titleIfCameraViewIsVisible')"
    ></default-header>

    <back-btn :shouldShowModal="true"></back-btn>

    <div class="innerContent justifyContentFlexStart">
      <div class="camera-container text-center mb-2" v-if="!disablePlates">
        <camera
          ref="camera"
          @sendPhoto="prepareDataForSending"
          @setLoading="showLoader = $event"
          :style="{display: showLoader ? 'none' : 'block'}"
        ></camera>
        <preloader class="mt-4" v-if="showLoader" />
      </div>

      <p class="text-center text-uppercase" v-if="!disablePlates">
        <span class="small">{{ $t('ScanPlates.orManually') }}</span>
      </p>

      <div class="additionalPadding pb-5 mb-5">
        <button
          v-if="!showEnterPlates && !disablePlates"
          class="btn btn-outline-primary w-100 mb-4"
          @click.stop="toggleEnterPlates"
        >
          <font-awesome-icon :icon="['fas', 'keyboard']" :class="'mr-2'"></font-awesome-icon>
          {{$t('ScanPlates.enterPlateId')}}
        </button>

        <div v-if="showEnterPlates" class="form-group small-label mb-4">
          <label v-if="plates" for="plates-numbers">{{ $t('ScanPlates.enterPlateId') }}:</label>
          <input
            type="text"
            class="form-control"
            name
            id="plates-numbers"
            v-model="plates"
            aria-describedby="plates-number"
            :placeholder="$t('ScanPlates.enterPlateId')"
          />
        </div>

        <select-standard
          v-if="plates !== ''"
          :chosen="platesCountry.label"
          :list="platesSelectList"
          :label-key="'label'"
          :label="$t('ScanPlates.selectCountryAndType')"
          name="vehicle-country-select"
          @selected="vehicleCountrySelected"
        />

        <div v-if="searchByCarsDataWorks">
          <p class="text-center text-uppercase">
            <span v-if="!disablePlates" class="small">{{ $t('ScanPlates.OrSearchByCar')}}</span>
          </p>

          <button
            v-if="!searchByCarDetailsBool"
            class="btn btn-outline-primary w-100 mb-4"
            @click.stop="toggleShowSearchByCarDetailsBool"
          >
            <font-awesome-icon :icon="['fas', 'keyboard']" :class="'mr-2'"></font-awesome-icon>
            {{$t('ScanPlates.enterCarsData')}}
          </button>

          <div v-if="searchByCarDetailsBool">
            <SelectForSearchByCarDetails
              :chosen="carsData.selectedManufacturer"
              :list="carsData.manufacturers"
              :label="$t('ScanPlates.selectCarMake')"
              name="selectedManufacturer"
              @selected="setManufacturer"
            />
            <SelectForSearchByCarDetails
              :chosen="carsData.selectedModel"
              :list="carsData.models"
              :label="$t('ScanPlates.selectCarModel')"
              name="selectedModel"
              @selected="setModel"
            />
            <SelectForSearchByCarDetails
              :chosen="filters.fuel ? {name:filters.fuel} : null"
              :list="getFuelTypes"
              :label="$t('ScanPlates.selectCarFuel')"
              name="fuel"
              @selected="setFilter"
            />
            <SelectForSearchByCarDetails
              :chosen="filters.year ? {name:filters.year} : null"
              :list="getYears"
              :label="$t('ScanPlates.selectCarYear')"
              name="year"
              @selected="setFilter"
            />
            <SelectForSearchByCarDetails
              :chosen="carsData.selectedEngine"
              :list="getCars"
              :label="$t('ScanPlates.selectCarEngine')"
              name="selectedEngine"
              @selected="setEngine"
            />
          </div>
        </div>

        <button
          class="btn btn-primary w-100"
          v-if="plates !== ''"
          @click.prevent="setCarPlatesOrVin"
        >{{$t('general.continue')}}</button>
        <button
          class="btn btn-primary w-100"
          v-if="carsData.selectedEngine"
          @click.prevent="saveCarsData"
        >{{$t('general.continue')}}</button>
      </div>
    </div>

    <bottom-navigation></bottom-navigation>
  </fragment>
</template>

<script>
import 'jquery-circle-progress'
import { mapActions, mapGetters } from 'vuex'
import { HTTP } from '../http'
import Camera from '../components/Camera'
import DefaultHeader from '../partials/DefaultHeader'
import BottomNavigation from '../partials/BottomNavigation'
import SelectStandard from '../components/SelectStandard'
import SelectForSearchByCarDetails from '../components/SelectForSearchByCarDetails'
import BackBtn from '../components/BackBtn'
import _ from 'lodash'
import Preloader from '../components/Preloader'

export default {
  components: {
    DefaultHeader,
    BottomNavigation,
    SelectStandard,
    SelectForSearchByCarDetails,
    Camera,
    Preloader,
    BackBtn,
  },
  name: 'ScanPlates',
  data() {
    return {
      showLoader: false,
      camHeight: 500,
      showCamera: true,
      searchByCarDetailsBool: false,
      plates: '',
      vin: '',
      platesCountry: '',
      platesData: '',
      filters: {
        fuel: null,
        year: null
      },
      platesImage: {
        show: false,
        src: ''
      },
      vehicleTypeMap: {
        1: 'LV',
        2: 'O',
        3: 'ML'
      },
      vehicleData: '',
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      showEnterPlates: false,
      showEnterVin: false,
      cameraIsSupported: true,
      carsData: {
        manufacturers: [],
        selectedManufacturer: null,
        years: this.getYears,
        models: [],
        selectedModel: null,
        engines: [],
        selectedEngine: null
      },
      searchByCarsDataWorks: true
    };
  },

  beforeMount() {
    this.getConfigFromBackend();
    this.getManufacturers();
  },
  mounted() {
    $('.paddingToHide').css('padding-left', '0px');
    $('.paddingToHide').css('padding-right', '0px');

    const vehicleType = localStorage.getItem('exideVehicleType');
    if (vehicleType == 3) {
      this.$router.push({ path: '/testresult' });
    }
  },

  beforeDestroy() {
    $('.paddingToHide').css('padding-right', '15px');
    $('.paddingToHide').css('padding-left', '15px');
  },
  computed: {
    ...mapGetters({
      message: 'getMessage',
      user: 'getUser',
      currentClient: 'getCurrentClient',
      platesSelectList: 'getPlatesSelectList'
    }),

    disablePlates: function() {
      return this.vehicleTypeMap[window.localStorage.exideVehicleType] === 'O'; // disable scanning for trucks
    },

    getCars: function() {
      let cars = null;
      if (this.carsData && this.carsData.engines.length) {
        cars = this.carsData.engines;
      }

      if (this.filters.fuel) {
        cars = cars.filter(car => car.fuelType === this.filters.fuel);
      }
      if (this.filters.year) {
        cars = cars.filter(
          car => this.filters.year >= car.yearFrom && this.filters.year <= car.yearTo
        );
      }
      return cars;
    },

    getFuelTypes: function() {
      if (this.carsData.engines) {
        if (this.carsData.engines[0] && this.carsData.engines[0].fuelType) {
          return _(this.carsData.engines)
            .uniqBy('fuelType')
            .map(item => {
              return { type: 'fuel', name: item.fuelType };
            })
            .value();
        } else {
          return null;
        }
      }
      return null;
    },

    getYears: function() {
      if (this.getCars) {
        let yearsFull = [];
        let years = _(this.getCars)
          .flatMap(item => {
            return [item.yearFrom, item.yearTo];
          })
          .uniq()
          .remove(item => item !== null)
          .value();

        let yearMin = Math.min(...years);
        let yearMax = Math.max(...years);

        for (let i = yearMin; i <= yearMax; i++) {
          yearsFull.push({ type: 'year', name: i });
        }

        return yearsFull;
      }
      return null;
    }
  },
  watch: {
    'carsData.engines': function() {
      this.filters.fuel = null;
      this.filters.year = null;
    },
    'filters.fuel': function() {
      this.filters.year = null;
    },
    plates: function(newValue) {
      if (newValue !== '') {
        this.vin = '';
      }
    },
    platesSelectList(countries) {
      if (countries && countries.length > 0) {
        const country = countries.filter(country => {
          return country.code === this.user.country;
        });
        if (country.length > 0) {
          this.platesCountry = country[0];
        }
      }
    }
  },
  methods: {
    ...mapActions(['getConfigFromBackend', 'createVehicleByPlatesOrVin']),

    setFilter(name, filter) {
      this.filters[filter.type] = filter.name;
    },

    toggleEnterPlates() {
      this.showEnterPlates = !this.showEnterPlates;
      this.showEnterVin = !this.showEnterPlates;
      this.searchByCarDetailsBool = false;
      this.carsData.models = [];
      this.carsData.selectedModel = null;
      this.carsData.engines = [];
      this.carsData.selectedEngine = null;
      this.carsData.selectedManufacturer = null;
    },
    toggleEnterVin() {
      this.showEnterVin = !this.showEnterVin;
      this.showEnterPlates = !this.showEnterVin;
    },
    toggleShowSearchByCarDetailsBool() {
      this.searchByCarDetailsBool = !this.searchByCarDetailsBool;
      this.showEnterPlates = false;
      this.plates = '';
    },

    prepareDataForSending(image) {
      let formData = new FormData();
      formData.append('clientData', this.currentClient);
      formData.append('image', image);

      this.sendImageToBackend(formData);
    },

    sendImageToBackend(formData) {
      this.showLoader = true;
      HTTP.post('/api/plate-images', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          this.showEnterPlates = true
          this.plates = response.data.plates
          this.$toasted.show(response.data.message, {
            className: response.data.plates ? 'success' : 'error',
          })
        }).catch(error => {
          this.plates = ''
          this.platesData = ''
          this.$toasted.show(error.response?.data.message ?? this.$t('errors.generic'))
        }).finally(()=> {
          this.showLoader = false
      });
    },
    setCarPlatesOrVin() {
      let data = {
        clientData: this.currentClient,
        plates: this.plates,
        vin: this.vin,
        platesCountry: this.platesCountry.country || ''
      };
      this.createVehicleByPlatesOrVin(data)
        .then(response => {
          if (!response.data.error) {
            this.$router.push({ name: 'TestResult' });
          }
        })
        .catch(errorResponse => {
          if (errorResponse.data.message) {
            this.$toasted.show(errorResponse.data.message);
          } else {
            this.$toasted.show(this.$t('quote.somethingWrong'));
          }
        });
    },

    vehicleCountrySelected(dropdownName, selectedItem) {
      this.platesCountry = selectedItem;
    },
    getManufacturers() {
      HTTP.post('/api/manual-search/manufacturers', {
        vehicleType: this.vehicleTypeMap[window.localStorage.exideVehicleType]
      })
        .then(res => {
          this.carsData.manufacturers = res.data.map(item => {
            return { name: item.manuName, id: item.manuId };
          });
        })
        .catch(() => {
          this.searchByCarsDataWorks = false;
        });
    },
    setManufacturer(name, value) {
      if (value) {
        this.showEnterPlates = false;
        this.plates = '';
        this.carsData.models = [];
        this.carsData.selectedModel = null;
        this.carsData.engines = [];
        this.carsData.selectedEngine = null;
        this.carsData.selectedManufacturer = value;
        this.getModels(value.id);
      }
    },
    getModels(manufacturerId) {
      HTTP.post('/api/manual-search/models', {
        manufacturerId,
        vehicleType: this.vehicleTypeMap[window.localStorage.exideVehicleType]
      }).then(res => {
        this.carsData.models = res.data.map(item => {
          return {
            id: item.modelId,
            name: item.modelname
          };
        });
      });
    },
    setModel(name, value) {
      if (value) {
        this.carsData.selectedModel = value;
        this.carsData.selectedEngine = null;
        this.getEngines(value.id);
      }
    },
    getEngines(modelId) {
      HTTP.post('/api/manual-search/engines', {
        modelId,
        manufacturerId: this.carsData.selectedManufacturer.id,
        vehicleType: this.vehicleTypeMap[window.localStorage.exideVehicleType]
      }).then(res => {
        this.carsData.engines = res.data.map(item => {
          let yearFrom = item.vehicleDetails.yearOfConstrFrom.toString().substring(0, 4);
          let yearTo = item.vehicleDetails.yearOfConstrTo
            ? parseInt(item.vehicleDetails.yearOfConstrTo.toString().substring(0, 4), 10)
            : '';

          let vehicleData = {
            id: item.cardId ? item.cardId : item.vehicleDetails.carId,
            name: `${item.vehicleDetails.typeName} ${yearFrom} - ${yearTo}`,
            yearFrom,
            yearTo: yearTo ? yearTo : new Date().getFullYear(),
            fuelType: item.vehicleDetails.fuelType,
            modId: item.vehicleDetails.modId,
            manuId: item.vehicleDetails.manuId
          };

          return vehicleData;
        });
      });
    },
    setEngine(name, value) {
      if (value) {
        this.carsData.selectedEngine = value;
      }
    },
    saveCarsData() {
      this.$store.commit('SET_CURRENT_VEHICLE', {
        manufacturerId: this.carsData.selectedManufacturer.id,
        modelId: this.carsData.selectedModel.id,
        vehicleId: this.carsData.selectedEngine.id,
        vehicleType: this.vehicleTypeMap[window.localStorage.exideVehicleType],
        name: `${this.carsData.selectedManufacturer.name} ${this.carsData.selectedModel.name}`,
        plates: 'n/a'
      });
      this.$router.push({ name: 'TestResult' });
    }
  }
};
</script>


